import 'moment/locale/pt-br';
import moment from 'moment';
import 'moment/dist/locale/pt-br';

moment.locale('pt-br');

export default class UtilsDate {
  static today(format = 'YYYY-MM-DD') {
    return moment().format(format);
  }

  /**
   * @deprecated use 'UtilsDate.format2' instead
   */
  static format(value, format = 'DD/MM/Y', defaultValue = '', formatIn = undefined) {
    if (!value) return defaultValue;

    const momentDate = formatIn ? moment(value, formatIn, true) : moment(value);

    return momentDate.format(format);
  }

  static format2(
    value,
    { fromFormat, toFormat, defaultValue } = { fromFormat: 'Y-MM-DD', toFormat: 'DD/MM/Y', defaultValue: '' },
  ) {
    return value ? moment(value, fromFormat).format(toFormat) : defaultValue;
  }

  static isValid(value, format, strict = false) {
    if (!value) return false;
    return moment(value, format, strict).isValid();
  }

  static subtract(date, amount, type, format = 'Y-MM-DD') {
    return moment(date).subtract(amount, type).format(format);
  }

  static add(date, amount, type, format = 'Y-MM-DD') {
    return moment(date).add(amount, type).format(format);
  }

  static isBetween(date, begin, end, format = 'Y-MM-DD') {
    return moment(date, format).isBetween(moment(begin, format), moment(end, format), undefined, '[]');
  }

  static isBefore(date1, date2, format = 'Y-MM-DD') {
    return moment(date1, format).isBefore(moment(date2, format));
  }

  static isAfter(firstValue, secondValue, format = 'YYYY-MM-DD') {
    return moment(firstValue, format).isAfter(secondValue);
  }

  static generateDates(firstDate, lastDate) {
    if (!firstDate || !lastDate) return [];

    const dateArray = [];
    const stopDate = moment(lastDate).toDate();
    let currentDate = moment(firstDate).toDate();

    while (currentDate <= stopDate) {
      dateArray.push(new Date(currentDate));
      currentDate = moment(currentDate).add(1, 'day').toDate();
    }
    return dateArray;
  }

  static toDate(val, fromFormat) {
    if (!val) return undefined;

    if (fromFormat) return moment(val, fromFormat).toDate();

    return moment(val).toDate();
  }

  static toTimestamp(date) {
    return moment(date).valueOf();
  }

  static getFirstDayOfMonth(
    date,
    { fromFormat, toFormat } = { fromFormat: 'YYYY-MM-DD', toFormat: 'YYYY-MM-DD HH:mm:ss' },
  ) {
    return moment(date, fromFormat).startOf('month').format(toFormat);
  }

  static getLastDayOfMonth(
    date,
    { fromFormat, toFormat } = { fromFormat: 'YYYY-MM-DD', toFormat: 'YYYY-MM-DD HH:mm:ss' },
  ) {
    return moment(date, fromFormat).endOf('month').format(toFormat);
  }

  static dateRangeToTimestamp(dates) {
    const startOfDay = new Date(dates[0]);
    startOfDay.setUTCHours(0, 0, 0, 0);
    const endOfDay = new Date(dates[1]);
    endOfDay.setUTCHours(23, 59, 59, 999);
    return [startOfDay.getTime(), endOfDay.getTime()];
  }

  static monthDateRangeToTimestamp(dates) {
    const startOfMonth = new Date(`${dates[0]}-01T00:00:00`);
    const endOfMonth = new Date(`${dates[1]}-01T00:00:00`);
    endOfMonth.setMonth(endOfMonth.getMonth() + 1);
    endOfMonth.setDate(0);
    endOfMonth.setHours(23, 59, 59, 999);
    return [startOfMonth.getTime(), endOfMonth.getTime()];
  }

  static duration(start, end) {
    if (!start || !end) return '0ms';

    const ms = moment(end).diff(moment(start));
    const d = moment.duration(ms);

    // Mapeamos cada unidade e seu sufixo
    const unidades = [
      { valor: Math.floor(d.asDays()), sufixo: 'd' },
      { valor: d.hours(), sufixo: 'h' },
      { valor: d.minutes(), sufixo: 'm' },
      { valor: d.seconds(), sufixo: 's' },
      { valor: d.milliseconds(), sufixo: 'ms' },
    ];

    // Filtramos apenas o que é maior que zero e juntamos com espaço
    const partes = unidades.filter((u) => u.valor > 0).map((u) => `${u.valor}${u.sufixo}`);

    // Se tudo for zero (caso de datas iguais), retorna 0ms
    return partes.length > 0 ? partes.join(' ') : '0ms';
  }
}
